// `excel_read_range` pagination (M3 row e): the add-in mirrors the eval simulator's semantics
// (`evals/agent_v2/simulator/executor.py::excel_read_range`) so the model sees one contract.
//
// A range over `max_cells` is NOT a refusal: the first rows that fit are returned with
// `truncated: true`, `next_row` (first row not returned) and `requested_address`. Only a single
// row wider than `max_cells` cannot be cut by rows and is a `ResultTooLarge` error. Pure: no Office.js.
import { parseRange, rangeToA1 } from './a1';

export type ReadPage =
  | { ok: true; requested: string; address: string; cols: number; requestedRows: number; rows: number; truncated: boolean; nextRow: number | null }
  | { ok: false; reason: 'invalid'; message: string }
  | { ok: false; reason: 'too_wide'; cells: number; maxCells: number };

/** Window of `address` that fits in `maxCells`, or why it cannot be read. */
export function readPage(address: string, maxCells: number): ReadPage {
  let ref;
  try {
    ref = parseRange(address);
  } catch (e) {
    return { ok: false, reason: 'invalid', message: (e as Error).message };
  }
  const requested = rangeToA1(ref);
  const cols = ref.end.col - ref.start.col + 1;
  const requestedRows = ref.end.row - ref.start.row + 1;
  if (cols > maxCells) return { ok: false, reason: 'too_wide', cells: cols * requestedRows, maxCells };
  const rows = Math.min(requestedRows, Math.floor(maxCells / cols));
  const truncated = rows < requestedRows;
  const window = truncated ? rangeToA1({ start: ref.start, end: { row: ref.start.row + rows - 1, col: ref.end.col } }) : requested;
  return { ok: true, requested, address: window, cols, requestedRows, rows, truncated, nextRow: truncated ? ref.start.row + rows : null };
}
